import * as React from "react";
import { DomainDryRunConfig as IDomainDryRunConfig, DomainInput } from "./types/input";
import { exportZoneFile } from "./utils/zoneFileUtils";
import { NGButton } from "../../../newcomponents/button/Button";
import { notification } from "antd";
import { DomainDryRunConfigItem } from "./domainDryRunConfigItem";
import { ConsoleContext } from "../../../mobxStores/consoleContext/consoleContext";
import { useFormContext } from "react-hook-form";

interface Props {
  configs?: IDomainDryRunConfig[];
  label: "DNS Config" | "Ownership Config";
}
export const DomainDryRunConfig: React.FC<Props> = ({ label, configs = [] }) => {
  const { watch } = useFormContext<DomainInput>();
  const fMode = watch("mode");
  const fGvcAlias = watch("gvc.alias");
  const fBasicDomain = watch("basic.name");
  const fAdvancedDomain = watch("advanced.name");
  const fDomain = React.useMemo(() => {
    return fMode === "basic" ? fBasicDomain : fAdvancedDomain;
  }, [fMode, fBasicDomain, fAdvancedDomain]);

  if (!configs || configs.length < 1) {
    return null;
  }

  function handleDownload(content: string): void {
    const a: HTMLAnchorElement = document.createElement("a");
    a.style.display = "none";
    a.classList.add("cpln-temp-a");
    a.download = `cpln-${fDomain}-dns-config.txt`;
    try {
      const file = new Blob([content], {
        type: `text/plain`,
      });
      a.href = URL.createObjectURL(file);
      a.click();
    } catch (e) {
      notification.error({ message: `Unable to download item, error: ${e.message}` });
    }
  }

  function handleExportDNSZoneFile() {
    const val = exportZoneFile(
      configs.map((c) => ({
        host: c.host,
        type: c.type as any,
        value: c.value,
        ttl: c.ttl,
      })),
    );
    handleDownload(val);
  }

  return (
    <div className="my-4">
      <div className="flex items-center justify-between">
        <div className="font-semibold dryRunConfigLabel">{label}</div>
        <NGButton variant={"primary"} outlined size="small" type={"button"} onClick={handleExportDNSZoneFile}>
          Export Zone File
        </NGButton>
      </div>
      <div className="mt-2 table-labels px-4 py-1 border grid grid-cols-8">
        <div className="col-span-1">Type</div>
        <div className="col-span-1">Ttl</div>
        <div className="col-span-3">Host</div>
        <div className="col-span-3">Value</div>
      </div>
      {configs
        .filter((c) => {
          if (fMode === "basic" && label.includes("Ownership") && c.value !== ConsoleContext.org) {
            return false;
          }
          return true;
        })
        .map((c) => {
          if (c.value.includes("<gvcAlias>") && fGvcAlias) {
            c.value = c.value.replace("<gvcAlias>", fGvcAlias);
          }
          return c;
        })
        .map((c) => (
          <div className="px-4 py-1 border border-t-0 grid grid-cols-8 dryRunConfig">
            <DomainDryRunConfigItem small value={c.type} />
            <DomainDryRunConfigItem small value={String(c.ttl)} />
            <DomainDryRunConfigItem value={c.host} />
            <DomainDryRunConfigItem value={c.value} />
          </div>
        ))}
    </div>
  );
};
